import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import { Box } from '@mui/material'

export default function LogoSmall({ sx }) {
  return (
    <RouterLink to='/'>
      <Box
        component='img'
        src='/static/new-logo.png'
        sx={{ width: 60, height: 54, ...sx }}
      />
    </RouterLink>
  )
}

LogoSmall.propTypes = {
  sx: PropTypes.object,
}
